




































































































import Vue from "vue";
import { Subscription, MailFrequency, SubscriptionPatch, SourceMini } from "@infoland/iprova-api";
import storeHelper from "../../../store/store-helper";
import { UserSubscriptionProperty } from "@/enums";
import { SnackBarTimeout } from "@/enums";

export default Vue.extend({
    name: "SubscriptionsList",
    components: {},
    data: function () {
        return {
            neverFrequency: MailFrequency[MailFrequency.never],
            monthlyFrequency: "monthly", //enum is defined in iprova-api project which i don't want to update
            weeklyFrequency: MailFrequency[MailFrequency.weekly],
            dailyFrequency: MailFrequency[MailFrequency.daily],
            immediatelyFrequency: MailFrequency[MailFrequency.immediately],
            changedProperty: UserSubscriptionProperty
        };
    },
    computed: {
        //this will return all the modules that the subscriptions have
        currentModules(): SourceMini[] {
            let modules: SourceMini[] = [];
            this.subscriptions.forEach(element => {
                if (modules.findIndex(module => module.id === element.source_mini.id && module.name === element.source_mini.name) === -1) {
                    modules.push(element.source_mini);
                }
            });
            return modules;
        },
        mdAndDown(): boolean {
            return this.$vuetify.breakpoint.mdAndDown;
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    props: {
        subscriptions: { type: Array as () => Subscription[], default: null, required: true }
    },
    async created() {},
    methods: {
        getSubscriptionsByModule(module: SourceMini): Subscription[] {
            let filteredSubscriptions = this.subscriptions.filter(subscription => {
                return subscription.source_mini.id === module.id && subscription.source_mini.name.toLowerCase().includes(module.name.toLowerCase());
            });

            return filteredSubscriptions;
        },
        isFrequencySupported(item: Subscription, frequency: MailFrequency): boolean {
            return (item.supported_mail_frequencies as number[]).includes(frequency as number);
        },
        async saveSubscription(item: Subscription, changedProperty: UserSubscriptionProperty) {
            const subscriptionId = item.subscription_id;
            let subscriptionPatch: SubscriptionPatch;
            if (changedProperty === UserSubscriptionProperty.mail_frequency) {
                subscriptionPatch = {
                    mail_frequency: item.mail_frequency
                };
            } else if (changedProperty === UserSubscriptionProperty.show_in_messages_list) {
                subscriptionPatch = {
                    show_in_messages_list: item.show_in_messages_list
                };
            }
            const result = await storeHelper.subscriptionsStore.saveSubscriptionAsync(subscriptionId, subscriptionPatch);
            if (result) {
                storeHelper.siteStore.setSnackBarMessage(this.$t("settings.subscriptions.successfulSave").toString(), false, SnackBarTimeout.short);
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
            }
            this.$emit("update-filter");
        },
        isNotification(item) {
            return item.type === "notification";
        },
        isSubscribableNotification(item) {
            return this.isNotification(item) && !item.references_subscription_id && item.has_message;
        }
    }
});
